export enum IntegrationType {
    Undefined = 0,
    AAD = 'Azure Active Directory',
    Hubspot = 'Hubspot',
    Marketo = 'Marketo',
    Dynamics = 'Dynamics',
    Salesforce = 'Salesforce',
    Stripe = 'Stripe',
    Zoom = 'Zoom',
    Teams = 'Teams',
    FieldDrive = 'FieldDrive',
    Okta = 'Okta',
    PublicEventSso = 'PublicEventSso',
}
